import React from "react";
import styled from "styled-components";
import Image from "next/image";

// StarIcon SVG Helper
const StarIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="#FFAD00"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);

const LegacyTestimonialCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 32px;
  gap: 16px;
  width: 280px;
  height: 321px;
  background: #ffffff;
  border: 1px solid #d9dbde;
  border-radius: 8px;
  flex-shrink: 0;
  margin: 0 auto;

  @media (max-width: 1200px) {
    height: auto;
    min-height: 181px;
    width: 158px;
    padding: 13.5px 18px;
    gap: 9px;
    border-radius: 4.5px;
    margin: 0;
  }
`;

const LegacyTestimonialText = styled.div`
  width: 100%;
  font-family: "Noto Sans Thai", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;
  color: #5f6468;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  @media (max-width: 1200px) {
    font-size: 9px;
    line-height: 15px;
    flex: 1;
  }
`;

const LegacyTestimonialAuthor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  @media (max-width: 1200px) {
    height: auto;
    gap: 2px;
  }
`;

const LegacyAuthorName = styled.div`
  width: 100%;
  height: 28px;
  font-family: "JUST Sans", "Noto Sans Thai", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #202123;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  @media (max-width: 1200px) {
    font-size: 11.25px;
    line-height: 15px;
    font-weight: 600;
    height: auto;
  }
`;

const LegacyAuthorSource = styled.div`
  width: 100%;
  height: 26px;
  font-family: "Noto Sans Thai", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: #5f6468;
  display: flex;
  align-items: center;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  @media (max-width: 1200px) {
    font-size: 9px;
    line-height: 12px;
    height: auto;
  }
`;

const StarRating = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  &.star-sm {
    width: 120px;
    height: 24px;
    flex: none;
    order: 0;
    flex-grow: 0;

    .mobile-stars {
      display: none;
    }

    @media (max-width: 1200px) {
      width: auto;
      height: auto;

      .desktop-stars {
        display: none;
      }

      .mobile-stars {
        display: flex;
        flex-direction: row;
        gap: 1px;
      }
    }

    img {
      width: 120px;
      height: 24px;
    }
  }
`;

export interface CommentCardProps {
  comment: string;
  commenter: string;
  career?: string;
}

export const CommentCard = ({
  comment,
  commenter,
  career = "",
}: CommentCardProps) => {
  return (
    <LegacyTestimonialCard className="testimonial-card">
      <StarRating className="star-rating star-sm">
        <div className="desktop-stars">
          <Image
            alt="rating"
            src="/static/fiveStar.svg"
            width={120}
            height={24}
          />
        </div>
        <div className="mobile-stars">
          <StarIcon size={13.5} />
          <StarIcon size={13.5} />
          <StarIcon size={13.5} />
          <StarIcon size={13.5} />
          <StarIcon size={13.5} />
        </div>
      </StarRating>
      <LegacyTestimonialText className="testimonial-text">
        {comment}
      </LegacyTestimonialText>
      <LegacyTestimonialAuthor className="testimonial-author">
        <LegacyAuthorName className="author-name">{commenter}</LegacyAuthorName>
        <LegacyAuthorSource className="author-source">
          {career}
        </LegacyAuthorSource>
      </LegacyTestimonialAuthor>
    </LegacyTestimonialCard>
  );
};

CommentCard.defaultProps = {
  career: "",
};

export default CommentCard;
